import type { QuoteListRow } from 'src/api/db/apiQuote'

export const sortQuotesByCreatedAt = (quotes: QuoteListRow[]): QuoteListRow[] =>
  [...quotes].sort(
    (a, b) =>
      new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  )

export const filterQuotesByName = (
  quotes: QuoteListRow[],
  search: string
): QuoteListRow[] => {
  if (!search.trim()) return quotes
  const term = search.toLowerCase()
  return quotes.filter((quote) =>
    (quote.name ?? '').toLowerCase().includes(term)
  )
}
